import React from 'react'

import {
  Field,
  Label,
  InputWithSuggestions,
} from 'components/form'

const EditWork = ({ customer, employer, name, roles, onChange }) => (
  <React.Fragment>
    <Field>
      <Label htmlFor="customer">Hvem jobbet du for?</Label>
      <InputWithSuggestions
        id="customer"
        suggestionsType="customer"
        value={customer}
        onChange={e => onChange({ key: 'customer', value: e.target.value })}
        required
      />
    </Field>
    {/*<Field>
      <Label htmlFor="name">Prosjektnavn</Label>
      <Input
        id="name"
        type="text"
        placeholder="F.eks. MyGet, Team Front eller GV Sprint"
        value={name}
        onChange={e =>
          onChange({
            key: 'name',
            value: e.target.value,
          })
        }
      />
    </Field>
    <Field>
      <Label htmlFor="employer">Arbeidsgiver</Label>
      <Input
        id="employer"
        type="text"
        value={employer}
        onChange={e => onChange({ key: 'employer', value: e.target.value })}
      />
    </Field>
    <Field>
      <Label htmlFor="roles">Arbeidsoppgaver</Label>
      <RolesInput
        id="roles"
        value={roles}
        onChange={roles => onChange({ key: 'roles', value: roles })}
      />
      </Field>*/}
  </React.Fragment>
)

export default EditWork



// WEBPACK FOOTER //
// ./src/components/EditExperience/EditWork.js